import LogOutButton from "@Front/Components/DesignSystem/LogOutButton";
import { usePublicLegalStaticFromSiteConfig } from "@Front/Services/PublicSiteConfig/usePublicLegalStaticFromSiteConfig";
import { CommonMenuNavItems } from "./CommonMenuSectionItems";

type CommonMenuSectionProps = {
	isClientOrThirdParty: boolean;
};

export function CommonMenuSection(props: CommonMenuSectionProps): React.ReactElement {
	const publicLegal = usePublicLegalStaticFromSiteConfig();
	return (
		<>
			<CommonMenuNavItems isClientOrThirdParty={props.isClientOrThirdParty} userGuidePath={publicLegal.userGuideEntryPath} />
			<LogOutButton />
		</>
	);
}
